<template>
    <div>
        <h4>แสดงราคา +บาทของสินค้า</h4>
        <br>
        <div class="row form-group">
            <div class="col-4 text-right">
                <label>เลือกประเภทสินค้า</label>
            </div>
            <div class="col-6">
                <select class="form-control" v-model="form.product_type_id">
                    <option
                        v-for="options in optionProductType"
                        :value="options.value">{{ options.text }}</option>
                </select>
            </div>
        </div>
        <div class="row form-group" v-if="form.product_type_id == 1 || !form.product_type_id">
            <div class="col-4 text-right">
                <label>+บาทโฟม</label>
            </div>
            <div class="col-6">
                <b-form-select :options="add_foam" v-model="form.add_price_foam"></b-form-select>
            </div>
        </div>
        <div class="row form-group" v-if="form.product_type_id !== 1">
            <div class="col-4 text-right">
                <label>+เบ็ดเตล็ด</label>
            </div>
            <div class="col-6">
                <b-form-select :options="add_price_other" v-model="form.add_price_other"></b-form-select>
            </div>
        </div>
        <div class="col text-center">
            <button
                class="btn btn-success mb-3"
                @click="confirmOrder"
                style="margin-right: 20px">
                <icon name="save"></icon> บันทึก
            </button>
            <button
                class="btn btn btn-outline-secondary mr-1 mb-3"
                @click="closeModal">
                <icon name="times"></icon> ยกเลิก
            </button>
        </div>
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";
    import {mapState} from "vuex";

    export default {
        name: "AddPriceProductModal",
        components:{
            Multiselect,
        },
        data(){
            return {
                add_foam : [
                    {value:'',text:'เลือก +บาทโฟม'},
                    {value:1,text :'+1'},
                    {value:2,text :'+2'},
                    {value:3,text :'+3'},
                    {value:4,text :'+4'},
                    {value:5,text :'+5'},
                ],
                add_price_other : [
                    {value:'',text:'เลือก +เบ็ดเตล็ด'},
                    {value:1,text :'+10'},
                    {value:2,text :'+20'},
                    {value:3,text :'+30'},
                    {value:4,text :'+40'},
                    {value:5,text :'+50'},
                ],
                form : {
                    add_price_foam : '',
                    add_price_other : '',
                    product_type_id : "",
                }
            }
        },
        computed:{
            ...mapState({
                user: state => {
                    return state.Auth.user;
                },
                optionProductType : state =>{
                    return [
                        {
                            value: "",
                            text: "หมวดหมู่สินค้า"
                        },
                        ...state.ProductType.data.map(type => ({
                            value: type.id,
                            text: type.name
                        }))
                    ];
                },
            })
        },
        methods:{
            confirmOrder(){
                this.$emit('submit',this.form);
            },
            closeModal(){
                this.$emit('submit',false);
            }
        }
    }
</script>

<style scoped>

</style>
